import React, { useEffect, useState } from 'react';
import { DatePicker } from 'rsuite';
// import { edit_schedule_api } from '../utils/edit_schedule_service';

const TimeDatePicker = ({
  id,
  field,
  row,
  rowNode,
  colDef,
  cellMode,
  hasFocus,
  tabIndex,
  value,
  formattedValue,
  isEditable,
  api
}) => {
  const [dt, setDt] = useState(null);

  useEffect(() => {
    // console.log({ field, value, row });
    setDt(new Date(value));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handleChange = async (e) => {
    const date = new Date(e);
    // const dd = date.getDate();
    // const mm = date.getMonth();
    // const yyyy = date.getFullYear();
    // const hh = date.getHours();
    // const min = date.getMinutes();
    // const ss = date.getSeconds();

    // const d = `${yyyy}-${mm + 1}-${dd} ${hh}:${min}:${ss}`;
    // const { batch_no: batch_number, stp_id, test_name } = row;
    // const response = await edit_schedule_api({ batch_number, stp_id, test_name, [field]: d });
    console.log({ field });
    // if (response.status) {
    setDt(e);
    // console.log(e);
    // alert(response.message);
    if (field === "machine_start_time" || field === "pre_start_time") {
      // const diff = date.getTime() - new Date(row["machine_start_time"]).getTime();
      // const machine_end_time = new Date(new Date(row["machine_end_time"]).getTime() + diff);
      const startField = field === "machine_start_time" ? "machine_start_time" : "pre_start_time";
      const endField = field === "machine_start_time" ? "machine_end_time" : "pre_end_time";
      const diff = date.getTime() - new Date(row[startField]).getTime();
      const endTime = new Date(new Date(row[endField]).getTime() + diff);
      api.updateRows([{ id, [field]: e, [endField]: endTime }]);
      // console.log(machine_end_time);
      // const edd = machine_end_time.getDate();
      // const emm = machine_end_time.getMonth();
      // const eyyyy = machine_end_time.getFullYear();
      // const ehh = machine_end_time.getHours();
      // const emin = machine_end_time.getMinutes();
      // const ess = machine_end_time.getSeconds();
      // const met = `${eyyyy}-${emm}-${edd} ${ehh}:${emin}:${ess}`;
      // console.log(met);
      // api.updateRows([{ id, [field]: e, machine_end_time: machine_end_time }]);
      // console.log(row);
      // console.log(machine_end_time);
    } else {
      api.updateRows([{ id, [field]: e }]);
    }
    // }
    // else {
    //   alert(response.message);
    // }
  };
  return (
    <div>
      <DatePicker
        className="w-full color-[#084298]"
        format='yyyy-MM-dd HH:mm'
        calendarDefaultDate={dt}
        style={{ width: 200 }}
        value={dt}
        onChange={handleChange}
      />
    </div>
  );
};

export default TimeDatePicker;